import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=af391338&scoped=true&"
import script from "./sort.vue?vue&type=script&lang=ts&"
export * from "./sort.vue?vue&type=script&lang=ts&"
import style0 from "./sort.vue?vue&type=style&index=0&id=af391338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af391338",
  null
  
)

export default component.exports